function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// BACK UP

/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from 'react';
import Modal from '@hig/modal';
import PropTypes from 'prop-types';
import '@hig/fonts/build/ArtifaktElement.css';
import styled from 'styled-components';
import Footer from '@dhxete/footer';
import PageContainer from './PageContainer';
import ETEModalStyle from './ETEModalStyle';

const ETEModal = ({
  state,
  dispatch,
  mode = 'page',
  children,
  title,
  type = 'standard',
  footerProps
}) => {
  const {
    isWidgetOpen,
    curPage,
    hasExtension,
    expandFooterOnError,
    // Added for case page button down flow.
    newCmDetails,
    hasError,
    Error
  } = state;
  const showHeader = curPage !== 'signInSpinPage';
  const [expand, setExpand] = useState(false);
  const [extension, setExtension] = useState(false);
  const {
    hasQuestion,
    expandForGAC,
    expandForHULA
  } = footerProps;
  const pagesWithNoFooter = !hasQuestion;
  /**
   * When Case has more than 4 to 5 fields,
   * we need to move down buttons.
  */

  let makeFotterButtonsDown = false;

  if (newCmDetails) {
    makeFotterButtonsDown = curPage === 'createCasePage' && (newCmDetails.firstName || newCmDetails.lastName) && (Error || hasError);
  }
  /**
   * Adding this hook to set Iframe height extension immeidiate when
   * user clicks on back button from case page.
  */


  const [visitedNoFooterPage, setVisitedNoFooterPage] = useState(false);
  /**
   * This hook will expand the iFrame on Footer click when the widget is
   * open in AKN(aka page) version.
  */

  const handleExpansion = () => {
    // extend iframe height if user clicks on page.
    if (mode === 'page') window.top.postMessage('extend-iframe', '*');
    setExpand(true);
    setExtension(true);

    if (expand) {
      // narrow iframe.
      if (mode === 'page') window.top.postMessage('narrow-iframe', '*');
      setExpand(false);
      setExtension(false);
    }
  };
  /**
   * This hook is created when user opens Iframe footer and visit
   * any none Footer page, we do not want to show extra white space
   * at the Footer.
  */


  useEffect(() => {
    if (mode === 'page' && pagesWithNoFooter) {
      window.top.postMessage('narrow-iframe', '*');
      setVisitedNoFooterPage(true);
    }

    if (mode === 'page' && !pagesWithNoFooter) {
      window.top.postMessage('extend-iframe', '*');
      setVisitedNoFooterPage(false);
    }
  }, [curPage]);
  /**
   * This hook will trigger Footer extension on Error pages
   * only when its page mode.
  */

  useEffect(() => {
    if (mode === 'page' && !expand && expandFooterOnError) {
      setExpand(true);
      setExtension(true);
    }
  }, [expandFooterOnError]);
  const renderFooter = !['signInSpinPage', 'processSpinPage'].includes(curPage);
  return /*#__PURE__*/React.createElement(ETEModalStyle, {
    mode: mode,
    showHeader: showHeader,
    curPage: curPage,
    pagesWithNoFooter: pagesWithNoFooter,
    expand: expand,
    visitedNoFooterPage: visitedNoFooterPage,
    expandForGAC: expandForGAC,
    expandForHULA: expandForHULA
  }, /*#__PURE__*/React.createElement(Modal, {
    open: isWidgetOpen,
    type: type,
    title: showHeader ? title : '',
    onCloseClick: () => dispatch({
      type: 'CLOSE_WIDGET'
    }) // AVA-MODAL purpose.

  }, mode === 'page' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageContainer, {
    hasExtension: hasExtension
  }, children), renderFooter && /*#__PURE__*/React.createElement(ExpandableFooter, {
    expand: expand,
    pagesWithNoFooter: pagesWithNoFooter,
    visitedNoFooterPage: visitedNoFooterPage,
    makeFotterButtonsDown: makeFotterButtonsDown
  }, /*#__PURE__*/React.createElement(Footer, _extends({}, footerProps, {
    handleExpansion: handleExpansion,
    hasExtension: extension
  })))) : /*#__PURE__*/React.createElement(PageContainer, {
    hasExtension: extension
  }, children, renderFooter && /*#__PURE__*/React.createElement(Footer, _extends({}, footerProps, {
    handleExpansion: handleExpansion,
    hasExtension: extension
  })))));
};

const ExpandableFooter = styled.div`
  position: absolute;
  bottom: 30px;
  width: 90%;
  ${({
  pagesWithNoFooter
}) => pagesWithNoFooter ? `
    bottom: 30px !important;
    -moz-transition: 0s;
    -ms-transition: 0s;
    -o-transition: 0s;
    -webkit-transition: 0s;
    transition: 0s;
    overflow: 'hidden';
  ` : `
    -moz-transition: 0.2s;
    -ms-transition: 0.2s;
    -o-transition: 0.2s;
    -webkit-transition: 0.2s;
    transition: 0.2s ease-in-out;
    overflow: 'hidden';
  `};

  ${({
  visitedNoFooterPage
}) => visitedNoFooterPage && `
    -moz-transition: 0s;
    -ms-transition: 0s;
    -o-transition: 0s;
    -webkit-transition: 0s;
    transition: 0s;
    overflow: 'hidden';
  `}

  ${({
  makeFotterButtonsDown
}) => makeFotterButtonsDown && `
    bottom: -25px !important;
  `};

  ${({
  expand
}) => expand && `
    bottom: 210px;
  `}
`;
ETEModal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  title: PropTypes.string,
  type: PropTypes.string,
  state: PropTypes.object,
  dispatch: PropTypes.func,
  mode: PropTypes.string,
  footerProps: PropTypes.object
};
export default ETEModal;